import { buildShareCardSVG } from "./shareCardSvg";
import { buildStoryCardSVG } from "./storyCardSvg";
import { buildLinkedinCardSVG } from "./linkedinCardSvg";
import { buildMonthlyRecapReelSVG } from "./monthlyRecapReelSvg";

/**
 * Registry of all reel formats. UI is generated from this — add a new format
 * here and it appears in the ReelKit automatically.
 *
 * Each format declares:
 *   id, label, size (readable), width, height, aspectRatioClass,
 *   builder (props → svg string), kind ("member" | "community"), tags.
 */
export const REEL_FORMATS = [
    {
        id: "landscape-share",
        label: "X · Facebook · OpenGraph",
        size: "1200 × 630",
        width: 1200,
        height: 630,
        aspectRatioClass: "aspect-[1200/630]",
        builder: buildShareCardSVG,
        kind: "member",
        tags: ["X / Twitter", "Facebook", "OG"],
        captionTemplate: (user, cfg, number) =>
            `I'm EVIQ ${cfg.short} #${number} — ${user.trees_restored} trees restored, ${user.ocean_plastic_lbs} lbs of ocean plastic pulled, ${user.batteries_protected} batteries kept in service longer. Join me @ EVIQ Earth Initiative.`,
    },
    {
        id: "story-vertical",
        label: "Instagram Story / Reel · TikTok",
        size: "1080 × 1920",
        width: 1080,
        height: 1920,
        aspectRatioClass: "aspect-[9/16]",
        builder: buildStoryCardSVG,
        kind: "member",
        tags: ["Instagram", "TikTok", "YouTube Shorts"],
        captionTemplate: (user, cfg, number) =>
            `Every mile with EVIQ restores the planet. ${user.trees_restored} trees. ${user.ocean_plastic_lbs} lbs of plastic. ${cfg.short} #${number}. #EVIQ #EVLife`,
    },
    {
        id: "square-linkedin",
        label: "LinkedIn feed · Instagram square",
        size: "1080 × 1080",
        width: 1080,
        height: 1080,
        aspectRatioClass: "aspect-square",
        builder: buildLinkedinCardSVG,
        kind: "member",
        tags: ["LinkedIn", "Instagram feed"],
        captionTemplate: (user, cfg, number) =>
            `Driving with purpose. My EVIQ membership (${cfg.label} #${number}) has quietly restored ${user.trees_restored} trees and removed ${user.ocean_plastic_lbs} lbs of ocean plastic. Small choices, real outcomes.`,
    },
    {
        id: "monthly-recap",
        label: "Monthly Community Recap",
        size: "1080 × 1920",
        width: 1080,
        height: 1920,
        aspectRatioClass: "aspect-[9/16]",
        builder: buildMonthlyRecapReelSVG,
        kind: "community",
        tags: ["Instagram", "TikTok", "Community"],
        captionTemplate: () =>
            "This is what one month of the EVIQ community looks like. Powered by drivers who care.",
    },
];

export const getFormat = (id) => REEL_FORMATS.find((f) => f.id === id);
